import React from "react";
import SpeechButton from "./SpeechButton";

function LessonList({ subconcepts }) {
  return (
    <div className="lesson-list">
      {subconcepts.map((item) => (
        <div key={item.id} className="lesson">
          <h3>Subconcept {item.id}</h3>
          <p><strong>English:</strong> {item.english}</p>
          <p><strong>Hindi:</strong> {item.hindi}</p>
          <p><strong>Telugu:</strong> {item.telugu}</p>
          <p><em>Pronunciation:</em> {item.pronunciation}</p>
          <SpeechButton text={item.english} lang="en-US" label="Read English" />
          <SpeechButton text={item.hindi} lang="hi-IN" label="Read Hindi" />
          <SpeechButton text={item.telugu} lang="te-IN" label="Read Telugu" />
        </div>
      ))}
    </div>
  );
}

export default LessonList;
